import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import SaleReport from './../models/SaleReport';
import SaleReportByOrder from './../models/SaleReportByOrder';
import SaleReportBySKU from './../models/SaleReportBySKU';
import SaleDetailReportBySKU from './../models/SaleDetailReportBySKU';
import CashFlow from './../models/CashFlow';
import VoucherRedeemtion, { VoucherRedeemtionDetail } from './../models/VoucherRedeemtion';
import { get } from 'lodash';
import moment from 'moment';
import ReportCollaborator from '../models/ReportCollaborator';
import SaleDetailReportByHotel from 'models/SaleDetailReportByHotel';
import BundleReport from 'models/BundleReport';
import ReportBtbOrder from '../models/ReportBtbOrder';
import ReportBtbUseRoom from '../models/ReportBtbUseRoom';

export function getSaleReports(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.SALE_REPORT,
        params: params,
        parser: data => saleReportDataParser(data, params),
    }).get();
}

export function getSaleReportsByOrder(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.SALE_REPORT_BY_ORDER,
        params: params,
        parser: data => saleReportByOrderDataParser(data, params),
    }).get();
}

export function getSaleReportsBySKU(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.SALE_REPORT_BY_SKU,
        params: params,
        parser: data => saleReportBySkuDataParser(data, params),
    }).get();
}

export function getSaleDetailReportsBySKU(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.SALE_DETAIL_REPORT_BY_SKU,
        params: params,
        parser: data => saleDetaiReportBySkuDataParser(data, params),
    }).get();
}

export function getVoucherRedeemtions(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.REPORT_VOUCHER_REDEEMTION,
        params: params,
        parser: data => voucherRedeemDataParser(data, params),
    }).get();
}

export function getVoucherRedeemtionDetail(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.REPORT_VOUCHER_REDEEMTION_DETAIL,
        params: params,
        parser: data => voucherRedeemDetailParser(data, params),
    }).get();
}

export function exportVoucherRedeemtions(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.REPORT_EXPORT_VOUCHER_REDEEMTIONS,
        isDownload: true,
        params: params,
    }).get();
}

export function getCashFlowReport(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.REPORT_CASH_FLOW,
        params: params,
        parser: data => reportCashFlowParser(data, params),
    }).get();
}

export function getBundleReport(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.BUNDLE_REPORT,
        params: {...params, 
                startDate: moment(params.startDate).utc().startOf('day').toISOString(), 
                endDate: moment(params.endDate).utc().endOf('day').toISOString()},
        parser: data => reportBundleParser(data, params),
    }).get();
}

export function exportBundleReportExcelService(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.EXPORT_BUNDLE_REPORT_EXCEL,
        isDownload: true,
        params: {...params, startDate: params?.startDate || moment.utc().startOf('isoWeeks').toISOString(),
                            endDate: params?.endDate || moment.utc().endOf('days').toISOString()}
    }).get();
}

function voucherRedeemDataParser(data = {}, params = {}) {
    return {
        ...data.data,
        startDate: params.startDate && moment.utc(params.startDate),
        endDate: params.endDate && moment.utc(params.endDate),
        result: (data.data.result || []).map(item => new VoucherRedeemtion({
            ...item, detail: { ...(item.detail || {}), startDate: params.startDate, endDate: params.endDate }
        }))
    }
}

function voucherRedeemDetailParser(data = {}, params = {}) {
    return {
        ...data.data,
        startDate: params.startDate && moment.utc(params.startDate),
        endDate: params.endDate && moment.utc(params.endDate),
        result: (data.data.result || []).map(item => new VoucherRedeemtionDetail(item))
    }
}

const saleReportDataParser = (data = {}, params = {}) => new SaleReport({
    ...data.data,
    saleReportItems: {
        ...(get(data, 'data.saleReportItems') || {}),
        pageIndex: params.pageIndex || params.PageIndex,
        pageSize: params.pageSize || params.PageSize,
        startDate: params.startDate,
        endDate: params.endDate,
        orderBy: params.orderBy,
        orderByDesc: params.orderByDesc,
    },
});

const saleReportByOrderDataParser = (data = {}, params = {}) => new SaleReportByOrder({
    ...data.data,
    saleReportItems: {
        ...(get(data, 'data.saleReportItems') || {}),
        pageIndex: params.pageIndex || params.PageIndex,
        pageSize: params.pageSize || params.PageSize,
        startDate: params.startDate,
        endDate: params.endDate,
        orderBy: params.orderBy,
        orderByDesc: params.orderByDesc,
    },
});

const saleReportBySkuDataParser = (data = {}, params = {}) => new SaleReportBySKU({
    ...data.data,
    pageIndex: params.pageIndex || params.PageIndex,
    pageSize: params.pageSize || params.PageSize,
    startDate: params.startDate,
    endDate: params.endDate,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc
});

const saleDetaiReportBySkuDataParser = (data = {}, params = {}) => new SaleDetailReportBySKU({
    ...data.data,
    pageIndex: params.pageIndex || params.PageIndex,
    pageSize: params.pageSize || params.PageSize,
    startDate: params.startDate,
    endDate: params.endDate,
    OrderStatus: params.OrderStatus,
    OutletName: params.OutletName,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc
});

const reportCashFlowParser = (data = {}, params = {})=> {
    return {
        ...data.data,
        startDate: params.startDate && moment.utc(params.startDate),
        endDate: params.endDate && moment.utc(params.endDate),
        result: (data.data.result || []).map(item => new CashFlow({
            ...item, detail: { ...(item.detail || {}), startDate: params.startDate, endDate: params.endDate }
        }))
    }
}

const reportBundleParser = (data = {}, params = {}) => {
    return {
        startDate: params?.startDate && moment.utc(params.startDate) ,
        endDate: params?.endDate && moment.utc(params.endDate),
        pageIndex: data?.data?.pageIndex || 1,
        pageSize: data?.data?.pageSize || 10,
        totalCount: data?.data?.totalCount,
        result: (data?.data?.result || []).map(el => new BundleReport({...el, dataList: (data?.data?.result || [])}))
    }
}

const collaboratorReportsDataParser = (data = {}, params = {}) => {
    return new ReportCollaborator({
    ...data,
    pageIndex: params.pageIndex || params.PageIndex,
    pageSize: params.pageSize || params.PageSize,
    startDate: params.startDate,
    endDate: params.endDate,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc
})};

export function getCollaboratorReports(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.REPORT_COLLABORATOR,
        params: params,
        parser: data => collaboratorReportsDataParser(data.data, params),
    }).get();
}

export function crossCheckPMS(body) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.CROSS_CHECK_PMS,
    }).post(body);
}

export function exportCollaboratorReport(query) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.EXPORT_COLLABORATOR_REPORT,
        isDownload: true,
        params: query
    }).get();
}

export function getSaleDetailReportsByHotel(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.SALE_DETAIL_REPORT_BY_HOTEL,
        params: params,
        parser: data => saleDetaiReportByHotekDataParser(data, params),
    }).get();
}
const btbUseRoomReportsDataParser = (data = {}, params = {}) => {
    return new ReportBtbUseRoom({
    ...data,
    // pageIndex: params.pageIndex || params.PageIndex,
    // pageSize: params.pageSize || params.PageSize,
    // startDate: params.startDate,
    // endDate: params.endDate,
    // orderBy: params.orderBy,
    // orderByDesc: params.orderByDesc
})};

const btbOrderReportsDataParser = (data = {}, params = {}) => {
    return new ReportBtbOrder({
    ...data,
    pageIndex: params.pageIndex || params.PageIndex,
    pageSize: params.pageSize || params.PageSize,
    startDate: params.startDate,
    endDate: params.endDate,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc
})};

export function exportBtbOrderReports(query) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.EXPORT_BTB_ORDER_REPORT,
        isDownload: true,
        params: query
    }).get();
}

export function exportBtbUseRoomReports(query) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.EXPORT_BTB_USE_ROOM_REPORT,
        isDownload: true,
        headers: { 'accept-language': "all" },
        params: query
    }).get();
}

export function getBtbOrderReports(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.REPORT_BTB_ORDER,
        params: params,
        parser: data => btbOrderReportsDataParser(data.data, params),
    }).get();
}

export function getBtbUseRoomReports(params) {
    return new ApiService({
        baseURL: Config.API_REPORT,
        endpoint: Urls.REPORT_BTB_USE_ROOM,
        headers: { 'accept-language': "all" },
        params:params,
        parser: data => { return btbUseRoomReportsDataParser(data)}
    }).get();
}

const saleDetaiReportByHotekDataParser = (data = {}, params = {}) => new SaleDetailReportByHotel({
    ...data.data,
    pageIndex: params.pageIndex || params.PageIndex,
    pageSize: params.pageSize || params.PageSize,
    startDate: params.startDate,
    endDate: params.endDate,
    orderBy: params.orderBy,
    orderByDesc: params.orderByDesc
});
